<template>
  <div>
    <img v-if="content[index].pic.length==0" style="width:100%;" src="https://api-xiangyou.dierqudao.com/public/images/no-pic.png" alt="" srcset="">
    <img style="width:100%" v-else :src="content[index].pic[0].url" alt />
  </div>
</template>

<script>

    export default {
        name: "SlidePics",
        components: {
            
        },
        props: {
            content: {
                type: Array,
                default: [],
            },

            top: {
                type: String,
                default: '',
            }

        },

        data: function () {
            return {
                timer: '',
                duration: 300,
                index:0
            }
        },

        methods: {
            indexChange(){
                this.index+=1
                if(this.index>this.content.length-1){
                    this.index=0
                }
            }

        },
        mounted(){
            this.timer = setInterval(this.indexChange, 3000);
        },
        beforeDestroy() {
      clearInterval(this.timer);
    },

        filters: {}

    };
</script>

<style scoped>
.van-swipe-item img {
  height: 262.5px;
  width: 100%;
}
</style>